/**
 * FBCOL = FIREBASE COLLECTION
 */
export const FBCOL_USER_ALARMS = "userAlarms";
